export const types = [
  'Add Country',
  'Add Product',
  'Change Budget',
  'Change Merchant Exclusivity',
  'Change Product Budget',
  'Change Runtime',
  'Change Target',
  'End Campaign',
  'Move Budget To Wallet',
  'Pause Campaign',
  'Refresh SKU',
  'Transfer Budget',
  'Unpause Campaign',
];

export const changeStatuses = {
  pending: 'Pending',
  granted: 'Granted',
  denied: 'Denied',
  withdrawn: 'Withdrawn',
  rejectedByClient: 'Rejected By Client',
  waitingForClientSignature: 'Waiting For Client Signature',
};

export const inActiveStatuses = [
  changeStatuses.granted,
  changeStatuses.denied,
  changeStatuses.withdrawn,
];

// Used only in specs
export const reviewerTypes = {
  owner: 'Owner',
  onsite: 'Onsite',
  displaySearch: 'DisplaySearch',
  paidSocial: 'PaidSocial',
  creative: 'Creative',
  ci: 'Ci',
  otherBusiness: 'OtherBusiness',
};

export const approvalStatuses = {
  pending: 'Pending',
  granted: 'Granted',
  denied: 'Denied',
};

export const CHANGE_PRODUCT_BUDGET = 'Change Product Budget';

export const TRANSFER_BUDGET = 'Transfer Budget';
